import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.weak-map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import fetchAPI from 'utils/http/fetchAPI';
import fileUploadConfig from 'utils/upload/fileUploadConfig';
import UploadStatus from 'utils/upload/UploadStatus';
import FileUploader from 'utils/upload/FileUploader/FileUploader';
import UploadsCoordinatorError from 'utils/errors/upload/UploadsCoordinatorError';
var completeMultipartUpload = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(parts, uploadId, s3Path, type) {
    var requestUrl, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            requestUrl = '/v2/completeMultipartUpload';
            body = {
              parts: parts,
              uploadId: uploadId,
              s3Path: s3Path,
              type: type
            };
            _context.next = 4;
            return fetchAPI(requestUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function completeMultipartUpload(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var _beginUpload = /*#__PURE__*/new WeakMap();
var UploadsCoordinator = /*#__PURE__*/function () {
  function UploadsCoordinator() {
    var _this = this;
    _classCallCheck(this, UploadsCoordinator);
    _defineProperty(this, "uploadFile", function (params) {
      return new Promise(function (resolve, reject) {
        navigator.locks.request(_this.uploadTrackingLock, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!_this.uploading) {
                    _context2.next = 3;
                    break;
                  }
                  _this.filesToUploadParams.push({
                    params: params,
                    promise: {
                      resolve: resolve,
                      reject: reject
                    }
                  });
                  return _context2.abrupt("return");
                case 3:
                  _this.uploading = true;
                  _classPrivateFieldGet(_beginUpload, _this).call(_this, params, {
                    resolve: resolve,
                    reject: reject
                  });
                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
      });
    });
    _classPrivateFieldInitSpec(this, _beginUpload, /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params, promise) {
        var _params, projectId, file, uploadUrlParams, type, abortController, onStatusUpdate, options, uploadId, bucket, key, _uploadParams, _fileUploader, _parts;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _params = _slicedToArray(params, 7), projectId = _params[0], file = _params[1], uploadUrlParams = _params[2], type = _params[3], abortController = _params[4], onStatusUpdate = _params[5], options = _params[6];
                _context4.prev = 1;
                uploadId = uploadUrlParams.uploadId, bucket = uploadUrlParams.bucket, key = uploadUrlParams.key;
                if (!(!uploadId || !bucket || !key)) {
                  _context4.next = 5;
                  break;
                }
                throw new Error('uploadUrlParams must contain uploadId, bucket, and key');
              case 5:
                _uploadParams = {
                  projectId: projectId,
                  uploadId: uploadId,
                  bucket: bucket,
                  key: key
                };
                _fileUploader = new FileUploader(file, fileUploadConfig.chunkSize, _uploadParams, abortController, onStatusUpdate, options);
                onStatusUpdate(UploadStatus.UPLOADING);
                _context4.next = 10;
                return _fileUploader.upload();
              case 10:
                _parts = _context4.sent;
                _context4.next = 13;
                return completeMultipartUpload(_parts, uploadId, key, type);
              case 13:
                onStatusUpdate(UploadStatus.UPLOADED);
                promise.resolve();
                _context4.next = 21;
                break;
              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](1);
                promise.reject(new UploadsCoordinatorError(_context4.t0.message));
                console.error(_context4.t0);
              case 21:
                // Begin next upload
                navigator.locks.request(_this.uploadTrackingLock, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var _this$filesToUploadPa, nextParams, nextPromise;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (_this.filesToUploadParams.length > 0) {
                            _this$filesToUploadPa = _this.filesToUploadParams.shift(), nextParams = _this$filesToUploadPa.params, nextPromise = _this$filesToUploadPa.promise;
                            _classPrivateFieldGet(_beginUpload, _this).call(_this, nextParams, nextPromise);
                          } else {
                            _this.uploading = false;
                          }
                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));
              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 17]]);
      }));
      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }());
    this.filesToUploadParams = [];
    this.uploading = false;
    this.uploadTrackingLock = 'uploadTrackingLock';
  }
  _createClass(UploadsCoordinator, null, [{
    key: "get",
    value: function get() {
      if (!UploadsCoordinator.instance) UploadsCoordinator.instance = new UploadsCoordinator();
      return UploadsCoordinator.instance;
    }
  }]);
  return UploadsCoordinator;
}();
export default UploadsCoordinator;